export enum TourSide {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
  Over = 'over',
}

export enum TourAlignment {
  Start = 'start',
  Center = 'center',
  End = 'end',
}

export enum TourStepAction {
  Click = 'click',
  Checkbox = 'checkbox',
}
